export default "__VITE_ASSET__C5R8U5Q2__"